import af from './af.js'
import ar from './ar.js'
import az from './az.js'
import be from './be.js'
import bg from './bg.js'
import ca from './ca.js'
import cs from './cs.js'
import da from './da.js'
import de from './de.js'
import el from './el.js'
import en from './en.js'
import es from './es.js'
import et from './et.js'
import eu from './eu.js'
import fi from './fi.js'
import fr from './fr.js'
import ga from './ga.js'
import hr from './hr.js'
import hu from './hu.js'
import hy from './hy.js'
import id from './id.js'
import it from './it.js'
import ja from './ja.js'
import ko from './ko.js'
import lt from './lt.js'
import ms from './ms.js'
import nl from './nl.js'
import no from './no.js'
import pl from './pl.js'
import pt from './pt.js'
import ro from './ro.js'
import ru from './ru.js'
import sk from './sk.js'
import sq from './sq.js'
import sv from './sv.js'
import th from './th.js'
import tl from './tl.js'
import tr from './tr.js'
import uk from './uk.js'
import zhCN from './zh-cn.js'
import zhTW from './zh-tw.js'

export default {
  af,
  ar,
  az,
  be,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  eu,
  fi,
  fr,
  ga,
  hr,
  hu,
  hy,
  id,
  it,
  ja,
  ko,
  lt,
  ms,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  sk,
  sq,
  sv,
  th,
  tl,
  tr,
  uk,
  'zh-cn': zhCN,
  'zh-tw': zhTW,
}
